import React, { useState, useEffect } from "react";

const Tables: React.FC = () => {
    const [tableData, setTableData] = useState<any[]>([]);
    const [questions, setQuestions] = useState<any[]>([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [columnNames, setColumnNames] = useState<string[]>([]);
    const [error, setError] = useState(false);
    const [showImage, setShowImage] = useState(false);
    const [selectedOption, setSelectedOption] = useState<number | null>(null);

    const objects = [
        "Apples",
        "Bananas",
        "Oranges",
        "Grapes",
        "Cars",
        "Trucks",
        "Dogs",
        "Cats",
        "Books",
        "Pens",
        "Chocolates",
        "Bottles",
        "Hats",
        "Shoes",
        "Bags",
        "Pencils",
        "Erasers",
        "Kites",
        "Balls",
        "Lamps",
    ];

    const dynamicColumnNames = [
        "Year 2019",
        "Year 2020",
        "Year 2021",
        "Year 2022",
        "Year 2023",
        "Year 2024",
        "Year 2025",
    ];

    // Generate random table data
    const generateTableData = () => {
        const selectedObjects = [];
        const usedIndices = new Set<number>();

        while (selectedObjects.length < 4) {
            const randomIndex = Math.floor(Math.random() * objects.length);
            const column2Value = Math.floor(Math.random() * 50) + 10; // Random value for column 2
            const column3Value = Math.floor(Math.random() * 40) + 20; // Random value for column 3
            const column4Value = Math.floor(Math.random() * 60) + 15; // Random value for column 4

            if (!usedIndices.has(randomIndex)) {
                selectedObjects.push({
                    object: objects[randomIndex],
                    column2: column2Value,
                    column3: column3Value,
                    column4: column4Value,
                });
                usedIndices.add(randomIndex);
            }
        }
        return selectedObjects;
    };

    // Generate random column names
    const generateColumnNames = () => {
        const shuffledNames = [...dynamicColumnNames].sort(() => Math.random() - 0.5);
        return shuffledNames.slice(0, 3);
    };

    // Generate dynamic questions based on the table data
    const generateQuestions = (data: any[], columnNames: string[]) => {
        const totalColumn2 = data.reduce((sum, item) => sum + item.column2, 0);
        const maxColumn2 = Math.max(...data.map((item) => item.column2));
        const maxColumn2Object = data.find((item) => item.column2 === maxColumn2)?.object;

        return [
            {
                question: `How many ${data[0].object} are sold in ${columnNames[0]}?`,
                answer: data[0].column2,
            },
            {
                question: `What is the total count for ${columnNames[0]}?`,
                answer: totalColumn2,
            },
            {
                question: `Which object has the highest count in ${columnNames[0]}?`,
                answer: maxColumn2Object,
            },
            {
                question: `What is the count of ${data[2].object} in ${columnNames[1]}?`,
                answer: data[2].column3,
            },
            {
                question: `What is the total count for ${columnNames[2]}?`,
                answer: data.reduce((sum, item) => sum + item.column4, 0),
            },
        ];
    };

    useEffect(() => {
        handleQuestion()
        document.title = "Mamas Guidance - Class One - Mathematics - Data Handling - Table"; // Set page title
    }, []);

    const handleQuestion = () => {
        const columnNames = generateColumnNames();
        const tableData = generateTableData();
        setColumnNames(columnNames);
        setTableData(tableData);
        setQuestions(generateQuestions(tableData, columnNames));
        setCurrentQuestionIndex(Math.floor(Math.random() * 3) + 1);
    };

    const handleAnswerSubmit = (userAnswer: any) => {
        setSelectedOption(userAnswer);
        const correctAnswer = questions[currentQuestionIndex].answer;
        if (userAnswer === correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                handleQuestion();
                setShowImage(false);
                setError(false);
            }, 5000);
        } else {
            setShowImage(false);
            setError(true);
        }
    };

  

    return (
        <>
            {showImage === false ? (
                <>
                    <div className="contentPart showCenter additionWord">
                        <div>
                            <table style={{ width: "100%", border: "1px solid #ccc", marginBottom: "20px" }}>
                                <thead>
                                    <tr>
                                        <th style={{ padding: "8px", border: "1px solid #ccc" }}>Object</th>
                                        {columnNames.map((name, index) => (
                                        <th key={index} style={{ padding: "8px", border: "1px solid #ccc" }}>
                                            {name}
                                        </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableData.map((row, index) => (
                                        <tr key={index}>
                                        <td style={{ padding: "8px", border: "1px solid #ccc" }}>{row.object}</td>
                                        <td style={{ padding: "8px", border: "1px solid #ccc" }}>{row.column2}</td>
                                        <td style={{ padding: "8px", border: "1px solid #ccc" }}>{row.column3}</td>
                                        <td style={{ padding: "8px", border: "1px solid #ccc" }}>{row.column4}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <h4>Question</h4>
                            <p>{questions[currentQuestionIndex]?.question}</p>

                            <div className=" bargraph"  style={{ margin: "20px 0", display: "flex", "flexWrap": "wrap", "gap": "30px" }}>
                                {typeof questions[currentQuestionIndex]?.answer === "number" ? (
                                    [questions[currentQuestionIndex].answer - 2, questions[currentQuestionIndex].answer, questions[currentQuestionIndex].answer + 2]
                                        .sort(() => Math.random() - 0.5) // Shuffle options
                                        .map((option, idx) => (
                                            <div style={{ width: 'auto', padding: '10px', fontSize: '30px' }}
                                                className={`background-blue ${
                                                selectedOption === option
                                                    ? option === questions[currentQuestionIndex].answer
                                                        ? 'correct'
                                                        : 'incorrect'
                                                    : ''
                                            }`}
                                                key={idx} onClick={() => handleAnswerSubmit(option)}>
                                            {option}
                                        </div>
                                        ))
                                    ) : (
                                    tableData.map((row, idx) => (
                                        <div style={{ width: 'auto', padding: '10px', fontSize: '30px' }}
                                            className={`background-blue ${
                                            selectedOption === row.object
                                                ? row.object === questions[currentQuestionIndex].answer
                                                    ? 'correct'
                                                    : 'incorrect'
                                                : ''
                                        }`}
                                            key={idx} onClick={() => handleAnswerSubmit(row.object)}>
                                        {row.object}
                                        </div>
                                    ))
                                )}
                            </div>
                            {error && <p className="error-text">❌ Oops! Try again.</p>}
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="contentPart showMiddle">
                        <img
                            style={{ height: '150px' }}
                            className="img-fluid"
                            src={process.env.REACT_APP_WELDONE_LINK}
                            alt="Well Done"
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default Tables;
